/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Confirm_Approve_InInputs */

const vi_sl_detail_confirm_approve_in = /** @type {(inputs: Sl_Detail_Confirm_Approve_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyệt phiếu nhập này?`)
};

/**

* @param {Sl_Detail_Confirm_Approve_InInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_confirm_approve_in = /** @type {((inputs?: Sl_Detail_Confirm_Approve_InInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Confirm_Approve_InInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_confirm_approve_in(inputs)
});